import { AxiosResponse } from 'axios';
import axiosInstance from '../shared/api/axios-instance';

export async function clearCRMCache(): Promise<AxiosResponse<string>> {
  return axiosInstance({
    method: 'GET',
    url: 'maintenance/clearCache'
  });
}

export async function clearAllCaches(): Promise<AxiosResponse<string>> {
  return axiosInstance({
    method: 'GET',
    url: 'maintenance/clearAllCaches'
  });
}
